module.exports = __webpack_public_path__ + "media/images/design/common/images/side_menu_li_bg1-e69a9a903c033c0080f84c09cfd0d511.png";